
























































































































































































































































export default function (Component) {
  Component.options.__source = "src/module/butler/views/page-recycle-bin.vue"
}
